// import pages
// import * as Sentry from "@sentry/browser";
// import React from "react";
import { createRoot } from "react-dom/client";
import DateRangeInput from "./components/DateRangeInput";

const root = createRoot(document.getElementById("dange_range_input_root"));
root.render(<DateRangeInput />);

console.log('date_range_input.tsx initialised')
